export class UpdateTableDataQualitySettingsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "settings",
            "baseName": "settings",
            "type": "TableDataQualitySettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateTableDataQualitySettingsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
